export type RateEntry = {
  rate: number;
  startAt: string;
  endAt: string;
  period?: string;
};

export enum StatementEntryItemType {
  Interest = "Interest",
  BaseRate = "Base Rate",
  DefaultInterest = "Default Interest",
  Fee = "Fee",
  Draw = "Draw",
  Payment = "Payment",
}

export type StatementEntryItemViewModel = {
  type: StatementEntryItemType;
  amount: number;
};

export class StatementEntryViewModel {
  constructor(
    public date: string,
    public description: string,
    public debit: number,
    public credit: number,
    public balance: number,
    public items: StatementEntryItemViewModel[]
  ) {
    this.date = date;
    this.description = description;
    this.debit = debit;
    this.credit = credit;
    this.balance = balance;
    this.items = items;
  }
}

export type AmortizationViewModel = {
  startAt: string;
  endAt: string;
  remainingBalance: number;
  entries: StatementEntryViewModel[];
  interestRates: RateEntry[];
  baseRates: RateEntry[];
  defaultInterests: RateEntry[];
};
